module.exports = __webpack_public_path__ + "img/slide1.5bbd2b93.png";